/* tslint:disable */
/* eslint-disable */
/**
 * React-app-base API
 * API react-app-base
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { NastaveniUpdateVO } from '../model';
// @ts-ignore
import { NastaveniVO } from '../model';
/**
 * GlobalSettingsControllerApi - axios parameter creator
 * @export
 */
export const GlobalSettingsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} pracovnikId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        load: async (pracovnikId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pracovnikId' is not null or undefined
            assertParamExists('load', 'pracovnikId', pracovnikId)
            const localVarPath = `/api/global-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pracovnikId !== undefined) {
                localVarQueryParameter['pracovnikId'] = pracovnikId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} pracovnikId 
         * @param {NastaveniVO} [nastaveniVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save: async (pracovnikId: number, nastaveniVO?: NastaveniVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pracovnikId' is not null or undefined
            assertParamExists('save', 'pracovnikId', pracovnikId)
            const localVarPath = `/api/global-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pracovnikId !== undefined) {
                localVarQueryParameter['pracovnikId'] = pracovnikId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nastaveniVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalSettingsControllerApi - functional programming interface
 * @export
 */
export const GlobalSettingsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlobalSettingsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} pracovnikId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async load(pracovnikId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NastaveniVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.load(pracovnikId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} pracovnikId 
         * @param {NastaveniVO} [nastaveniVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async save(pracovnikId: number, nastaveniVO?: NastaveniVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NastaveniUpdateVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.save(pracovnikId, nastaveniVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GlobalSettingsControllerApi - factory interface
 * @export
 */
export const GlobalSettingsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlobalSettingsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} pracovnikId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        load(pracovnikId: number, options?: any): AxiosPromise<NastaveniVO> {
            return localVarFp.load(pracovnikId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} pracovnikId 
         * @param {NastaveniVO} [nastaveniVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save(pracovnikId: number, nastaveniVO?: NastaveniVO, options?: any): AxiosPromise<NastaveniUpdateVO> {
            return localVarFp.save(pracovnikId, nastaveniVO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GlobalSettingsControllerApi - interface
 * @export
 * @interface GlobalSettingsControllerApi
 */
export interface GlobalSettingsControllerApiInterface {
    /**
     * 
     * @param {number} pracovnikId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalSettingsControllerApiInterface
     */
    load(pracovnikId: number, options?: any): AxiosPromise<NastaveniVO>;

    /**
     * 
     * @param {number} pracovnikId 
     * @param {NastaveniVO} [nastaveniVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalSettingsControllerApiInterface
     */
    save(pracovnikId: number, nastaveniVO?: NastaveniVO, options?: any): AxiosPromise<NastaveniUpdateVO>;

}

/**
 * GlobalSettingsControllerApi - object-oriented interface
 * @export
 * @class GlobalSettingsControllerApi
 * @extends {BaseAPI}
 */
export class GlobalSettingsControllerApi extends BaseAPI implements GlobalSettingsControllerApiInterface {
    /**
     * 
     * @param {number} pracovnikId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalSettingsControllerApi
     */
    public load(pracovnikId: number, options?: any) {
        return GlobalSettingsControllerApiFp(this.configuration).load(pracovnikId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} pracovnikId 
     * @param {NastaveniVO} [nastaveniVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalSettingsControllerApi
     */
    public save(pracovnikId: number, nastaveniVO?: NastaveniVO, options?: any) {
        return GlobalSettingsControllerApiFp(this.configuration).save(pracovnikId, nastaveniVO, options).then((request) => request(this.axios, this.basePath));
    }
}
